import { useEffect } from "react";
import { _ } from "i18n";
import { TooltipComponent } from "../TooltipComponent/TooltipComponent";
import { Gender } from "./types";

export interface GenderOptionsInput {
	male: boolean;
	female: boolean;
}

interface GenderSelectionProps {
	value: Gender;
	onChange: (gender: Gender) => void;
	/** When omitted, both options are treated as available. */
	genderOptions?: GenderOptionsInput;
}

export function GenderSelection({ value, onChange, genderOptions }: GenderSelectionProps) {
	const femaleEnabled = genderOptions == null || genderOptions.female;
	const maleEnabled = genderOptions == null || genderOptions.male;

	// When both are disabled, treat male as enabled (fallback).
	const effectiveMaleEnabled = maleEnabled || !femaleEnabled;
	const effectiveFemaleEnabled = femaleEnabled;

	useEffect(() => {
		if (!effectiveMaleEnabled && value === Gender.MALE) {
			onChange(Gender.FEMALE);
		}
	}, [effectiveMaleEnabled, value, onChange]);

	const maleLabel = (
		<label className={value === Gender.MALE ? "gender-options__item is-selected" : "gender-options__item"}>
			<input
				checked={value === Gender.MALE}
				type="radio"
				name="gender"
				value={Gender.MALE}
				onChange={(e) => onChange(e.target.value as Gender)}
				className="gender-options__input"
			/>
			<span className="gender-options__text">{_("portal.gender.Male")}</span>
		</label>
	);

	const maleDisabledLabel = (
		<label className="gender-options__item">
			<input type="radio" name="gender" value={Gender.MALE} disabled className="gender-options__input" tabIndex={-1} />
			<span className="gender-options__text">{_("portal.gender.Male")}</span>
		</label>
	);

	const femaleDisabledLabel = (
		<label className="gender-options__item">
			<input type="radio" name="gender" value={Gender.FEMALE} disabled className="gender-options__input" tabIndex={-1} />
			<span className="gender-options__text">{_("portal.gender.Female")}</span>
		</label>
	);

	return (
		<div className="gender-selection">
			<span className="gender-selection__label">{_("videos.table.th.category")}</span>
			<div className="gender-options" role="radiogroup" aria-label={_("videos.table.th.category")}>
				{effectiveMaleEnabled ? (
					maleLabel
				) : (
					<TooltipComponent title={_("tooltip.purchase.gender")} variant="dark" delay={500} size="large">
						{maleDisabledLabel}
					</TooltipComponent>
				)}
				{effectiveFemaleEnabled ? (
					<label
						className={value === Gender.FEMALE ? "gender-options__item is-selected" : "gender-options__item"}
					>
						<input
							checked={value === Gender.FEMALE}
							type="radio"
							name="gender"
							value={Gender.FEMALE}
							onChange={(e) => onChange(e.target.value as Gender)}
							className="gender-options__input"
						/>
						<span className="gender-options__text">{_("portal.gender.Female")}</span>
					</label>
				) : (
					<TooltipComponent title={_("tooltip.purchase.gender")} variant="dark" delay={500} size="large">
						{femaleDisabledLabel}
					</TooltipComponent>
				)}
			</div>
		</div>
	);
}
